module.exports = __webpack_public_path__ + "static/media/debutant.d9f288cc.svg";